<template>
  <b-sidebar
    id="add-new-sidebar"
    :visible="isUpdateSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @change="(val) => $emit('update:is-update-sidebar-active', val)"
  ><template #default="{ hide }">
    <!-- Header -->
    <div
      class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
    >
      <h5 class="mb-0">
        Update role
      </h5>

      <feather-icon
        class="ml-1 cursor-pointer"
        icon="XIcon"
        size="16"
        @click="hide"
      />
    </div>

    <!-- BODY -->
    <validation-observer
      #default="{ handleSubmit }"
      ref="refFormObserver"
    >
      <!-- Form -->
      <b-form
        class="p-2"
        @submit.prevent="handleSubmit(onSubmit)"
        @reset.prevent="resetForm"
      >
        <!-- Skill Name -->
        <validation-provider
          #default="validationContext"
          name="name"
          rules="required"
        >
          <b-form-group
            label="Name"
            label-for="name"
          >
            <b-form-input
              id="name"
              v-model="skill.name"
              :state="getValidationState(validationContext)"
              trim
            />

            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <!-- Skill Slug -->
        <validation-provider
          #default="validationContext"
          name="type"
          rules="required"
        >
          <b-form-group
            label="Type"
            label-for="type"
          >
            <b-form-input
              id="slug"
              v-model="skill.type"
              :state="getValidationState(validationContext)"
              trim
            />

            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <!-- Skill Type -->
        <validation-provider
          #default="validationContext"
          name="description"
          rules="required"
        >
          <b-form-group
            label="Description"
            label-for="type"
          >
            <b-form-input
              id="description"
              v-model="skill.desc"
              :state="getValidationState(validationContext)"
              trim
            />

            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <validation-provider
          #default="validationContext"
          name="permissions"
          rules="required"
        >
          <b-form-group
            label="Permisssions"
            label-for="permissions"
          >
            <div id="app">
              <treeselect
                v-model="skill.permissions"
                :multiple="true"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="calcPermissions"
              />
            </div>
            <b-form-invalid-feedback>
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Update Role
          </b-button>
          <b-button
            type="button"
            variant="outline-secondary"
            @click="hide"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </template></b-sidebar>
</template>
<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import { mapActions, mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import useSkillsList from './useRolesList'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    Treeselect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    isUpdateSidebarActive: {
      required: true,
      type: Boolean,
    },
    skill: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapGetters({
      Permissions: 'profile/getAllPermissions',
    }),
    calcPermissions() {
      return this.Permissions.map(row => ({ id: row._id, label: row.name }))
    },
    // calcSelectedPer() {
    //   return this.skill.permissions.map(row => row._id)
    // },
  },
  methods: {
    ...mapActions({
      fetchPermission: 'profile/retreivePermissions',
    }),
  },
  created() {
    this.fetchPermission()
  },
  setup(props, { emit }) {
    const { skillStatuses, updateSkill } = useSkillsList()

    const { refFormObserver, getValidationState, resetForm } = formValidation()

    const onSubmit = async () => {
      const response = await updateSkill(props.skill)
      if (typeof response !== 'undefined') {
        emit('refetch-data')
        emit('update:is-update-sidebar-active', false)
      }
    }

    return {
      refFormObserver,
      getValidationState,
      skillStatuses,
      resetForm,
      onSubmit,
    }
  },
}
</script>
